<template>
  <div class="header">
    <div class="max-width col-block width-full">
      <div class="main-container container-block row-block">
        <div class="left-container row-block">
          <div v-if="false" :style="{ width: '30px' }"></div>
          <router-link class="logo-container row-block" :to="{ name: 'main' }">
            <img class="logo-icon" :src="require('../../assets/images/header-logo.svg')" alt="">
            <div :style="{ width: '10px' }"></div>
            <div class="logo-title">{{ 'InheriNext'/* ___ */ }}</div>
          </router-link>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="center-container">
        </div>
        <div class="right-container row-block" :style="{ flex: 1 }">
          <div :style="{ flex: 1 }"></div>
          <template v-if="false">
            <!-- <div v-if="locale" class="locale-container input-group" :style="{ width: '120px' }">
              <select v-model="locale" @change="e => switchLang()">
                <option value="tc">繁體中文</option>
                <option value="en">English</option>
              </select>
            </div> -->
            <div class="tab-list-container row-block height-full">
              <component
                v-for="(option, index) in tabOptions"
                :is="option.to ? 'router-link' : 'div'"
                :to="option.to"
                class="tab-field center-block"
                :class="{ active: option.active }"
                :key="index"
                @click="e => option.func && option.func()"
              >
                <div class="tab-container row-block">
                  <div class="tab-block row-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="tab-title">{{ option.title }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </component>
            </div>
            <div :style="{ width: '12%', 'max-width': '190px' }"></div>
            <div :style="{ width: '30px' }"></div>
          </template>
          <template v-else>
            <div class="option-container row-block">
              <div class="icon-block" :style="{ '--size': '30px' }" @click="e => display['menu'] = !display['menu']">
                <img :src="display['menu'] ? require('../../assets/icons/menu-close-icon.svg') : require('../../assets/icons/menu-open-icon.svg')" alt="">
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="display['menu'] && true" class="menu-list-container col-block width-full">
        <component
          v-for="(option, index) in tabOptions"
          :is="option.to ? 'router-link' : 'div'"
          :to="option.to"
          class="menu-field center-block"
          :class="{ active: option.active }"
          :key="index"
          @click="e => menuOnClick(option)"
        >
          <div class="menu-container row-block">
            <div class="menu-block row-block">
              <div :style="{ flex: 1 }"></div>
              <div class="menu-title">{{ option.title }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deleteUser } from '../../api'
import { Validator } from 'vee-validate'
import toastMethods from '../../mixins/toastMethods.vue'
import responsitive from '../../mixins/responsitive.vue'
import loginData from '../../mixins/loginData.vue'
import i18n from '../../constants/lang/i18n'

export default {
  mixins: [
    toastMethods,
    responsitive,
    loginData
  ],
  data () {
    return {
      locale: null,
      display: {
        menu: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'user'
    ]),
    // static
    tabOptions () {
      return [
        {
          title: '什麼是基因檢測？ 何時需要？'/* ___ */,
          func: () => this.toSection(1)
        },
        {
          title: 'InheriNext 優勢在哪？ 口碑如何？'/* ___ */,
          func: () => this.toSection(2)
        },
        {
          title: '檢測服務價格？'/* ___ */,
          func: () => this.toSection(3)
        },
        {
          title: '多久可以看報告？我要怎麼開始？'/* ___ */,
          func: () => this.toSection(4)
        }
      ]
    }
  },
  watch: {
    '$route.name' () {
      this.display['menu'] = false
    }
  },
  created () {
    const languageMap = l => {
      if (!l) return null
      l = l.toLowerCase()
      if (l === 'zh-cn') return 'sc'
      if (l.startsWith('zh')) return 'tc'
      return 'en'
    }
    this.locale = localStorage.getItem('locale') || languageMap(window.navigator.language || navigator.userLanguage) || 'tc'
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setSectionAction'
    ]),
    switchLang () {
      i18n.locale = this.locale
      Validator.localize(this.locale)
      localStorage.setItem('locale', this.locale)
    },
    menuOnClick (option) {
      this.display['menu'] = false
      option.func && option.func()
    },
    toSection (num) {
      this.setSectionAction(num)
    },
    userLogin () {
      this.setModalAction({
        action: 'login',
        width: '400px'
      })
    },
    async userLogout () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await deleteUser(config)
        this.setUserData(null)
        this.addToast('success', response.data.result)
        this.$router.push({ name: 'main' })
      } catch (error) {
        this.setLoginAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/header.vue